// Generated by pnpm --filter @langfuse/icons generate. Do not edit.
import { createIcon } from "../../create-icon.js";
import { Archive as RawArchive } from "lucide-react";
export const Archive = /* @__PURE__ */ createIcon(RawArchive, "Archive", 2);
